import React, { useState, useEffect, useCallback } from 'react';
import {
    Grid,
    TextField,
    Select,
    MenuItem,
    Typography,
    InputLabel,
    FormControl,
    Chip,
    InputAdornment,
    Button,
    styled,
    AccordionDetails,
    Accordion,
    AccordionSummary,
    Autocomplete,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../../../redux/loader/actions';
import { showSnackbar } from '../../../../redux/snackbar/actions';
import commonApi from '../../../../services/common';
import subscribeApi from '../../../../services/subscribe';
import updateInformationApi from '../../../../services/managelicense';
import { ArrowForward } from '@mui/icons-material';
import updateApi from '../../../../services/subscribe';
import IconButton from '@mui/material/IconButton';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../../../utils';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import productApi from '../../../../services/product';

const CustomSelect = styled(Select)(() => ({
    '& .MuiOutlinedInput-notchedOutline': {
        border: 0
    },
    '& .MuiSelect-select': {
        padding: '0 8px'
    },
    '& .MuiInputBase-input': {
        display: 'flex',
        alignItems: 'center'
    }
}));

function BusinessInformation({
    onNext,
    formData,
    setFormData,
    businesssid,
    licensebusinesssid,
    setBusTitle,
    busTitle,
    isEditing,
    setIsEditing,
    bas,
    bass,
    setBas,
    setBass,
    setLanguageType,
    languageType,
    loanNumberType,
    setLoanNumberType
}) {
    const { productid, busUid, businessuuid } = useParams();
    const menuItems = useSelector((state) => state.menuReducer.items);
    const createMenuItem = menuItems?.find((item) => item.name.toLowerCase() === 'subscriptions');
    const isDisabled = createMenuItem?.access_type === 'read_write';
    const [licenses, setLicenses] = useState([]);
    const [newLicense, setNewLicense] = useState({ number: '', name: '' });
    const [licenseToEdit, setLicenseToEdit] = useState(null);
    const [countryCodes, setCountryCodes] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCodeMobile, setSelectedCodeMobile] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [logoID, setLogoID] = useState(null);
    const [ids, setIds] = useState({});
    const [proUUID, setProUUID] = useState();

    const [incrementDigits, setIncrementDigits] = useState(6);
    const [incrementMethod, setIncrementMethod] = useState('');
    const [separator, setSeparator] = useState('-');
    useEffect(() => {
        setProUUID(productid);
    }, []);

    const proid = getDecryptedCookie('proid');
    const business = getDecryptedCookie('buslap');
    const businessId = getDecryptedCookie('bi');
    const business_uuid = getDecryptedCookie('bss');
    const organizationItems = useSelector((state) => state.organizationReducer.items);
    const [states, setStates] = useState([]);
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const dispatch = useDispatch();
    const [nextBtn, setNextBtn] = useState(false);

    const handleCloseAlert = () => {
        setOpenAlertDialog(false);
    };
    const handleConfirmChange = () => {
        handleCloseAlert();
        updateBillingInformation();
        setEditMode(false);
    };

    const getBusinessData = useCallback(
        (businessuuid) => {
            const onSuccess = (res) => {
                if (res?.data?.status) {
                    setBusTitle(res?.data?.data);
                }
            };
            const onFailure = (err) => {};
            productApi.getBusinessName(businessuuid).then(onSuccess, onFailure);
        },
        [busTitle]
    );

    const stateList = useCallback(() => {
        dispatch(showLoader());

        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res.data.status === true) {
                setStates(res.data.data);
            } else {
                console.error('Failed to fetch data');
            }
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch data', err);
        };

        commonApi.getAllState().then(onSuccess).catch(onFailure);
    }, [dispatch]);

    useEffect(() => {
        stateList();
    }, [stateList]);

    useEffect(() => {
        removeCookie('lll');
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (business && business_uuid) {
                setNextBtn(true);
            }
        }, 4000);
        return () => {
            clearInterval(interval);
        };
    }, [business && business_uuid]);

    const getCountryCode = useCallback(() => {
        const onSuccess = (res) => {
            const codes = res.data.data.map((country) => ({
                code: `+${country.phone_code}`,
                country_code: country.country_code,
                country_name: country.country_name,
                min_mobile_length: country.min_mobile_length,
                max_mobile_length: country.max_mobile_length,
                mast_countries_uuid: country.mast_countries_uuid
            }));
            const sortedCodes = codes.sort((a, b) => a.country_code.localeCompare(b.country_code));
            setCountryCodes(sortedCodes);

            const defaultCode = sortedCodes.find((option) => option.country_code === 'IN');
            if (defaultCode) {
                setSelectedCodeMobile(defaultCode);
                setSelectedCountry({
                    phone_code: defaultCode.code,
                    min_mobile_length: defaultCode.min_mobile_length,
                    max_mobile_length: defaultCode.max_mobile_length
                });
            }
        };

        const onFailure = (err) => {
            console.error('Failed to fetch data', err);
            setCountryCodes([]);
        };

        commonApi.countryCode().then(onSuccess).catch(onFailure);
    }, []);

    useEffect(() => {
        getCountryCode();
    }, [getCountryCode, organizationItems]);
    useEffect(() => {
        removeCookie('lll');
    }, []);

    const createBusinessDetails = useCallback(
        (data) => {
            removeCookie('lll');
            dispatch(showLoader());
            const form = {
                address: data.area,
                bus_allias_name: busTitle?.business_alias_name,
                bus_gst_in: data.gstin || null,
                bus_name: busTitle?.business_name,
                mobile_number: data.mobilenumber,
                input_language: data.inputlanguage,
                bus_logo_id: logoID || data.businesslogo,
                country_code: selectedCountry?.phone_code,
                created_by: 1,
                sso_id: busTitle?.business_uuid,
                loan_number_type: loanNumberType,
                digit: loanNumberType === 'general' ? 5 : incrementDigits,
                loan_split_symbols:
                    loanNumberType !== 'general'
                        ? data.loan_split_symbols === 'Space'
                            ? ' '
                            : data.loan_split_symbols
                        : '-',
                increment_method: loanNumberType === 'license_scheme_increment' ? data.increment_method : null
            };
            console.log('Payload being sent:', form);
            setLanguageType(data.inputlanguage);
            setEncryptedCookie('lll', data.inputlanguage);
            const onSuccess = (res) => {
                dispatch(hideLoader());
                onNext();
            };
            const onFailure = (err) => {
                dispatch(hideLoader());
                console.error('Failed to create business', err);
            };
            updateApi.updateBusinessdetails(proUUID, data?.idp, data?.idt, form).then(onSuccess, onFailure);
            subscribeApi.createBusinessDetails(form).then(onSuccess, onFailure);
        },
        [busTitle, logoID, selectedCountry, loanNumberType, incrementDigits, separator]
    );
    const fileUpload = useCallback((formData) => {
        dispatch(showLoader());
        subscribeApi
            .fileUpload(formData)
            .then((res) => {
                dispatch(hideLoader());
                dispatch(
                    showSnackbar({
                        message: 'File uploaded successfully',
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        variant: 'success'
                    })
                );
                if (res.data.status) {
                    setLogoID(res.data.data[0].uuid);
                } else {
                    console.error('File UUID not found in response');
                }
            })
            .catch((error) => {
                console.error('Error submitting data:', error);
            });
    }, []);

    const formik = useFormik({
        initialValues: {
            gstin: busTitle?.business_gst || null,
            area: businesssid?.data?.[0]?.address || '',
            mobilenumber: businesssid?.data?.[0]?.mobile_number || '',
            inputlanguage: businesssid?.data?.[0]?.input_language || '',
            businesslogo: businesssid?.data?.[0]?.bus_logo_id || null,
            countrycode: businesssid?.data?.[0]?.country_code || selectedCountry?.country_code,
            idp: businesssid?.data?.[0]?.business_uuid || null,
            idt: businesssid?.data?.[0]?.sso_business_uuid || null,
            legal_entity: busTitle?.legal_entity_name || null,
            billing_address: busTitle?.billing_address || null,
            state: busTitle?.state_lookup_id || null,
            loan_number_type: 'general',
            digit: 6,
            loan_split_symbols: '-',
            increment_method: ''
        },
        validationSchema: Yup.object({
            gstin: Yup.string()
                .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/, 'Invalid GST format')
                .length(15, 'GST must be exactly 15 characters long'),

            legal_entity: Yup.string().when('gstin', {
                is: (gstin) => gstin && gstin.length === 15,
                then: (schema) =>
                    schema
                        .required('Legal entity name is required')
                        .min(3, 'Legal entity name must be at least 3 characters')
                        .max(100, 'Legal entity name must not exceed 100 characters'),
                otherwise: (schema) => schema.notRequired()
            }),

            billing_address: Yup.string().when('gstin', {
                is: (gstin) => gstin && gstin.length === 15,
                then: (schema) =>
                    schema
                        .required('Billing address is required')
                        .min(20, 'Billing address must be at least 20 characters')
                        .max(250, 'Billing address must not exceed 250 characters'),
                otherwise: (schema) => schema.notRequired()
            }),

            state: Yup.string().required('Address is required'),
            area: Yup.string()
                .required('Address is required')
                .min(20, 'Address must be at least 20 characters')
                .max(256, 'Address must be at most 140 characters'),
            mobilenumber: Yup.string()
                .required('Mobile Number is required')
                .matches(/^\d+$/, 'Mobile Number must be a valid number')
                .min(
                    selectedCountry?.min_mobile_length || 1,
                    `Mobile Number must be at least ${selectedCountry?.min_mobile_length || 1} digits`
                )
                .max(
                    selectedCountry?.max_mobile_length || 10,
                    `Mobile Number must not exceed ${selectedCountry?.max_mobile_length || 10} digits`
                )
                .nullable(),
            inputlanguage: Yup.string().required('Input Language is required'),
            businesslogo: Yup.mixed().nullable()
        }),
        onSubmit: (values) => {
            if (isDisabled) {
                createBusinessDetails(values);
            } else {
                onNext();
            }
        },

        enableReinitialize: true
    });
    const handleCancelEditing = () => {
        formik.setValues({
            gstin: busTitle?.business_gst || '',
            legal_entity: busTitle?.legal_entity_name || '',
            billing_address: busTitle?.billing_address || '',
            state: busTitle?.state_lookup_id
        });
    };

    useEffect(() => {
        formik.validateForm().then((errors) => {
            const hasErrors = Object.keys(errors).length > 0;
            sessionStorage.setItem('enableManageLicense', !hasErrors);
        });
    }, [formik.values]);

    useEffect(() => {
        setIsEditing(false);
        if (businesssid?.data && businesssid?.data?.length > 0) {
            const apiData = businesssid.data[0];
            const loanSplitSymbolsValue = apiData.loan_split_symbols === ' ' ? 'Space' : apiData.loan_split_symbols;
            formik.setValues({
                gstin: busTitle?.business_gst || '',
                area: businesssid?.data?.[0]?.address || '',
                mobilenumber: businesssid?.data?.[0]?.mobile_number || '',
                inputlanguage: businesssid?.data?.[0]?.input_language || '',
                legal_entity: busTitle?.legal_entity_name || '',
                billing_address: busTitle?.billing_address || '',
                state: busTitle?.state_lookup_id || '',
                businesslogo: businesssid?.data?.[0]?.bus_logo_id || null,
                countrycode: businesssid?.data?.[0]?.country_code || selectedCountry?.country_code,
                idp: businesssid?.data?.[0]?.business_uuid || null,
                idt: businesssid?.data?.[0]?.sso_business_uuid || null,
                loan_number_type: businesssid?.data?.[0]?.loan_number_type || 'general',
                digit: businesssid?.data?.[0]?.digit || 6,
                loan_split_symbols: apiData.loan_split_symbols === ' ' ? 'Space' : apiData.loan_split_symbols,
                increment_method: apiData.increment_method || ''
            });
            setIds({
                business: businesssid?.data?.[0]?.business_uuid,
                business_uuid: businesssid?.data?.[0]?.sso_business_uuid
            });
        }
    }, [businesssid, organizationItems]);

    useEffect(() => {
        setFormData(formik.values);
    }, [formik.values, setFormData, organizationItems]);

    const updateBillingInformation = useCallback(() => {
        dispatch(showLoader());
        const data = {
            state_lookup_id: formik.values.state,
            business_gst: formik.values.gstin,
            legal_entity_name: formik.values.legal_entity,
            billing_address: formik.values.billing_address
        };
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res.data.status === true) {
                dispatch(
                    showSnackbar({
                        message: 'Business Updated Successfully',
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        variant: 'success'
                    })
                );

                getBusinessData(businessuuid);
            }
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: 'Failed to upload',
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'error'
                })
            );
        };

        updateInformationApi.updateInformation(busTitle?.business_uuid, data).then(onSuccess).catch(onFailure);
    }, [dispatch, formik.values, busTitle?.business_uuid]);

    const generateLoanNumberPreview = (type, separator, digits) => {
        const alias = (busTitle?.business_alias_name || 'ALIAS').toUpperCase();
        const schemeAlias = 'GS';
        const sep =
            {
                None: '',
                Space: ' ',
                '-': '-',
                '/': '/',
                _: '_',
                '.': '.'
            }[separator] || '';
        const padded = String(1).padStart(digits, '0');

        switch (type) {
            case 'license_scheme_increment':
                return `${alias}${sep}${schemeAlias}${sep}${padded}`;
            case 'license_increment':
                return `${alias}${sep}${padded}`;
            case 'scheme_increment':
                return `${schemeAlias}${sep}${padded}`;
            case 'general':
            default:
                return '10000';
        }
    };

    useEffect(() => {
        if (formik.values.loan_number_type) {
            // Sync formik values back into parent state
            setLoanNumberType(formik.values.loan_number_type);
            setIncrementDigits(formik.values.digit || 6);
            setSeparator(formik.values.loan_split_symbols || '-');
            setIncrementMethod(formik.values.increment_method || '');
        }
    }, [formik.values.loan_number_type]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container justifyContent='flex-end' mb={2}>
                <Grid item></Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
                <Grid item xs={12} sm={4} md={4}>
                    <TextField
                        label='Business Name'
                        fullWidth
                        value={busTitle?.business_name}
                        name='businessname'
                        InputProps={{
                            readOnly: true
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <TextField
                        label='Business Alias Name'
                        fullWidth
                        value={busTitle?.business_alias_name}
                        name='businessaliasname'
                        InputProps={{
                            readOnly: true
                        }}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <FormControl fullWidth>
                        <InputLabel>Loan Number Type</InputLabel>
                        <Select
                            value={loanNumberType}
                            onChange={(e) => {
                                const selected = e.target.value;
                                setLoanNumberType(selected);
                                setIncrementDigits(6);
                                setSeparator('-');
                                setIncrementMethod(selected === 'license_scheme_increment' ? 'license_increment' : '');

                                formik.setFieldValue('loan_number_type', selected);
                                formik.setFieldValue('digit', 6);
                                formik.setFieldValue('loan_split_symbols', '-');
                                formik.setFieldValue(
                                    'increment_method',
                                    selected === 'license_scheme_increment' ? 'license_increment' : ''
                                );
                            }}
                            disabled={businesssid?.data?.[0]?.loan_exists === true}
                        >
                            <MenuItem value='general'>General Pawn Broker Method – 10000 Series (Default)</MenuItem>
                            <MenuItem value='license_scheme_increment'>
                                License Alias + Scheme Alias + Increment Number
                            </MenuItem>
                            <MenuItem value='license_increment'>License Alias + Increment Number</MenuItem>
                            <MenuItem value='scheme_increment'>Scheme Alias + Increment Number</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {['license_scheme_increment', 'license_increment', 'scheme_increment'].includes(loanNumberType) && (
                    <>
                        {/* Increment Digits */}
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl fullWidth>
                                <InputLabel>Increment Digits</InputLabel>
                                <Select
                                    value={formik.values.digit} // use formik value directly
                                    onChange={(e) => {
                                        const selected = e.target.value;
                                        formik.setFieldValue('digit', selected);
                                        setIncrementDigits(selected); // optional, or remove if unnecessary
                                    }}
                                    label='Increment Digits'
                                    disabled={businesssid?.data?.[0]?.loan_exists === true}
                                >
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={6}>6</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl fullWidth>
                                <InputLabel>Loan Number Separator</InputLabel>
                                <Select
                                    value={formik.values.loan_split_symbols} // use formik value directly
                                    onChange={(e) => {
                                        const selected = e.target.value;
                                        formik.setFieldValue(
                                            'loan_split_symbols',
                                            selected === 'Space' ? ' ' : selected
                                        ); // Store actual space
                                        setSeparator(selected);
                                    }}
                                    label='Loan Number Separator'
                                    renderValue={(selected) => {
                                        return selected === ' ' ? 'Space' : selected;
                                    }}
                                    disabled={businesssid?.data?.[0]?.loan_exists === true}
                                >
                                    <MenuItem value='Space'>Space</MenuItem>
                                    <MenuItem value='-'>-</MenuItem>
                                    <MenuItem value='/'>/</MenuItem>
                                    <MenuItem value='_'>_</MenuItem>
                                    <MenuItem value='.'>.</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </>
                )}

                {loanNumberType === 'license_scheme_increment' && (
                    <Grid item xs={12} sm={4} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Increment Method</InputLabel>
                            <Select
                                value={formik.values.increment_method}
                                onChange={(e) => {
                                    formik.setFieldValue('increment_method', e.target.value);
                                    setIncrementMethod(e.target.value); // Keep this line for now, see explanation below
                                }}
                                disabled={businesssid?.data?.[0]?.loan_exists === true}
                                label='Increment Method'
                            >
                                <MenuItem value='license_increment'>License (Branch) alias basis</MenuItem>
                                <MenuItem value='license_scheme_increment'>License + Scheme alias basis</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                )}
                {['license_increment', 'license_scheme_increment', 'scheme_increment'].includes(loanNumberType) && (
                    <Grid item xs={12} sm={4} md={4}>
                        <TextField
                            fullWidth
                            label='Preview'
                            value={generateLoanNumberPreview(loanNumberType, separator, incrementDigits)}
                            InputProps={{ readOnly: true }}
                            variant='outlined'
                        />
                    </Grid>
                )}

                <Grid item xs={12} sm={4} md={4}>
                    {isDisabled && (
                        <TextField
                            type='file'
                            label='Business Logo'
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            inputProps={{ accept: '.png, .jpg, .jpeg' }}
                            onChange={(event) => {
                                const file = event.currentTarget.files[0];
                                if (file) {
                                    const allowedTypes = ['image/png', 'image/jpeg'];
                                    if (!allowedTypes.includes(file.type)) {
                                        dispatch(
                                            showSnackbar({
                                                message: 'Only PNG, JPG, and PDF files are allowed.',
                                                autoHideDuration: 3000,
                                                anchorOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'right'
                                                },
                                                variant: 'error'
                                            })
                                        );
                                        return;
                                    }

                                    const formData = new FormData();
                                    formData.append('files', file);
                                    formik.setFieldValue('businesslogo', file);
                                    fileUpload(formData);
                                }
                            }}
                            name='businesslogo'
                            error={formik.touched.businesslogo && Boolean(formik.errors.businesslogo)}
                        />
                    )}

                    {formik.touched.businesslogo && formik.errors.businesslogo && (
                        <Typography color='error'>{formik.errors.businesslogo}</Typography>
                    )}
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <TextField
                        label='Address'
                        fullWidth
                        value={formik.values.area}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name='area'
                        error={formik.touched.area && Boolean(formik.errors.area)}
                        helperText={formik.touched.area && formik.errors.area}
                        InputProps={{
                            readOnly: true
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <TextField
                        label='Mobile Number'
                        fullWidth
                        value={formik.values.mobilenumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        // disabled={isDisabled}
                        name='mobilenumber'
                        error={formik.touched.mobilenumber && Boolean(formik.errors.mobilenumber)}
                        helperText={formik.touched.mobilenumber && formik.errors.mobilenumber}
                        InputProps={{
                            readOnly: !isDisabled,
                            startAdornment: (
                                <InputAdornment position='start'>
                                    <FormControl>
                                        <CustomSelect
                                            value={selectedCodeMobile}
                                            disabled={!isDisabled}
                                            onChange={(event) => {
                                                const selected = event.target.value;
                                                if (selected) {
                                                    setSelectedCodeMobile(selected);
                                                    setSelectedCountry({
                                                        phone_code: selected.code,
                                                        min_mobile_length: selected.min_mobile_length,
                                                        max_mobile_length: selected.max_mobile_length
                                                    });
                                                }
                                            }}
                                            displayEmpty
                                        >
                                            {countryCodes.map((option) => (
                                                <MenuItem key={option.code} value={option}>
                                                    {option.country_code} ({option.code})
                                                </MenuItem>
                                            ))}
                                        </CustomSelect>
                                    </FormControl>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <FormControl fullWidth>
                        <InputLabel>Input Language</InputLabel>
                        <Select
                            label='Input Language'
                            value={formik.values.inputlanguage}
                            onChange={(e) => {
                                formik.handleChange(e);
                                setLanguageType(e.target.value);
                            }}
                            onBlur={formik.handleBlur}
                            name='inputlanguage'
                            error={formik.touched.inputlanguage && Boolean(formik.errors.inputlanguage)}
                            disabled={
                                !isDisabled ||
                                businesssid?.data?.[0]?.loan_exists ||
                                businesssid?.data?.[0]?.cust_exists
                            }
                        >
                            <MenuItem value='ta'>Tamil</MenuItem>
                            <MenuItem value='en'>English</MenuItem>
                            <MenuItem value='enta'>Tamil with English</MenuItem>
                        </Select>
                        {formik.touched.inputlanguage && formik.errors.inputlanguage && (
                            <Typography color='error'>{formik.errors.inputlanguage}</Typography>
                        )}
                    </FormControl>
                    {businesssid?.data?.[0]?.bus_logo_url ? (
                        <div style={{ marginTop: 10 }}>
                            <Typography sx={{ fontSize: '12px', color: '#a00', fontWeight: 'bold' }}>
                                Business Logo
                            </Typography>
                            <div style={{ marginTop: 5 }}>
                                <img
                                    src={businesssid?.data?.[0]?.bus_logo_url}
                                    alt='Business Logo'
                                    style={{ width: '30%', height: 'auto', marginBottom: 10 }}
                                />
                            </div>
                        </div>
                    ) : null}
                </Grid>

                <Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls='panel1-content'
                            id='panel1-header'
                        >
                            <Typography
                                mt={0}
                                sx={{
                                    mb: 0,
                                    fontWeight: 600,
                                    fontSize: 18
                                }}
                            >
                                Billing Information
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ pt: 0 }}>
                            <Grid item xs={12} textAlign={'end'} mb={2} mt={-1}>
                                <Button size='small' sx={{ minWidth: 10 }} onClick={() => setEditMode(true)}>
                                    <ModeEditIcon />
                                </Button>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4} md={3}>
                                    <TextField
                                        label='GST IN'
                                        fullWidth
                                        value={formik.values.gstin}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            formik.setFieldValue('legal_entity', '');
                                            formik.setFieldValue('billing_address', '');
                                        }}
                                        onBlur={formik.handleBlur}
                                        name='gstin'
                                        error={formik.touched.gstin && Boolean(formik.errors.gstin)}
                                        helperText={formik.touched.gstin && formik.errors.gstin}
                                        disabled={!editMode}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Autocomplete
                                        options={states}
                                        getOptionLabel={(option) => option.value}
                                        value={
                                            states.find((option) => option.state_lookup_id === formik.values.state) ||
                                            null
                                        }
                                        onChange={(event, newValue) => {
                                            formik.setFieldValue('state', newValue ? newValue.state_lookup_id : '');
                                        }}
                                        disableClearable
                                        disabled={!editMode}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='State'
                                                error={formik.touched.state && Boolean(formik.errors.state)}
                                                helperText={formik.touched.state && formik.errors.state}
                                                sx={{ mb: 1 }}
                                            />
                                        )}
                                    />
                                </Grid>
                                {formik.values.gstin && !formik.errors.gstin && (
                                    <>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                label='Name of Legal Entity'
                                                fullWidth
                                                value={formik.values.legal_entity}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                disabled={!editMode}
                                                name='legal_entity'
                                                error={
                                                    formik.touched.legal_entity && Boolean(formik.errors.legal_entity)
                                                }
                                                helperText={formik.touched.legal_entity && formik.errors.legal_entity}
                                                sx={{ mb: 1 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                label='Billing Address'
                                                fullWidth
                                                value={formik.values.billing_address}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                disabled={!editMode}
                                                name='billing_address'
                                                error={
                                                    formik.touched.billing_address &&
                                                    Boolean(formik.errors.billing_address)
                                                }
                                                helperText={
                                                    formik.touched.billing_address && formik.errors.billing_address
                                                }
                                                sx={{ mb: 1 }}
                                            />
                                        </Grid>
                                    </>
                                )}
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    {editMode && (
                                        <Box display={'flex'}>
                                            <Button
                                                sx={{ mr: 2 }}
                                                variant='contained'
                                                size='small'
                                                disabled={Boolean(formik.errors.gstin)}
                                                onClick={() => {
                                                    setOpenAlertDialog(true);
                                                }}
                                            >
                                                Update
                                            </Button>
                                            <Button
                                                variant='contained'
                                                size='small'
                                                onClick={() => {
                                                    formik.setFieldValue('gstin', busTitle?.business_gst);
                                                    formik.setFieldValue('legal_entity', busTitle?.legal_entity_name);
                                                    formik.setFieldValue('billing_address', busTitle?.billing_address);
                                                    formik.setFieldValue('state', busTitle?.state_lookup_id);
                                                    setEditMode(false);
                                                    getBusinessData(businessuuid);
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                            <Dialog open={openAlertDialog} onClose={handleCloseAlert}>
                                <DialogTitle textAlign={'center'}>
                                    <ErrorOutlinedIcon sx={{ color: 'warning.main', fontSize: 50 }} />
                                    <Typography fontSize={20} fontWeight={600} color='primary'>
                                        Warning
                                    </Typography>
                                </DialogTitle>
                                <DialogContent>
                                    <Typography fontSize={16}>
                                        If you update the Billing details, all future invoices will reflect the updated
                                        details. Existing Invoices records will remain unchanged. Are you sure you want
                                        to continue?
                                    </Typography>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseAlert} color='primary'>
                                        Cancel
                                    </Button>
                                    <Button onClick={handleConfirmChange} color='primary'>
                                        Ok
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {businesssid && (
                            <Button
                                variant='outlined'
                                type='submit'
                                sx={{ flexGrow: 0 }}
                                onClick={() => {
                                    formik.handleSubmit();
                                }}
                            >
                                NEXT
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
}

export default BusinessInformation;
